import { render, staticRenderFns } from "./IconAktifPlusKey.vue?vue&type=template&id=72048c39&"
import script from "./IconAktifPlusKey.vue?vue&type=script&lang=js&"
export * from "./IconAktifPlusKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports